import type { TFunction } from "i18next";
import { z } from "zod";

export const BOOLEAN_ENUM = ["true", "false"] as const;
export type BooleanEnum = (typeof BOOLEAN_ENUM)[number];

export const getStep4Schema = (t: TFunction) =>
  z
    .object({
      importPower: z.string().optional(),
      exportPower: z.string().optional(),
      canSellEnergy: z.enum(BOOLEAN_ENUM, {
        message: t("step4.validation.canSellEnergy"),
      }),
      hasPvInstallation: z.enum(BOOLEAN_ENUM, {
        message: t("step4.validation.hasPvInstallation"),
      }),
      installationPower: z.string().optional(),
      inverterPower: z.string().optional(),
      voivodeship: z.string().optional(),
    })
    .superRefine((data, ctx) => {
      if (data.hasPvInstallation === "true" && !data.installationPower) {
        ctx.addIssue({
          code: "custom",
          path: ["installationPower"],
          message: t("step4.validation.installationPowerRequired"),
        });
      }
      if (data.hasPvInstallation === "true" && !data.voivodeship) {
        ctx.addIssue({
          code: "custom",
          path: ["voivodeship"],
          message: t("step4.validation.voivodeship"),
        });
      }

      if (data.canSellEnergy === "true" && !data.exportPower) {
        ctx.addIssue({
          code: "custom",
          path: ["exportPower"],
          message: t("step4.validation.exportPowerRecommended"),
        });
      }
    });

export type Step4Schema = z.infer<ReturnType<typeof getStep4Schema>>;

export type Step4FormKeys = keyof Step4Schema;
